/**
 * GiftHub shop-search capture (26 Oct 2026).
 * POSTs every storefront search (hits + zeros) to Giffy worker → D1 shop_search_daily.
 * Fire-and-forget; never blocks UX. No auth. Origin comes from the browser.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://gifthub-ai-gift-finder.gifthub-my.workers.dev/shop-search';
  var recent = Object.create(null);
  var DEDUPE_MS = 15000;

  function normalizeTerm(term) {
    return String(term || '').replace(/\s+/g, ' ').trim();
  }

  function clampResults(n) {
    n = Number(n);
    if (!isFinite(n) || n < 0) n = 0;
    if (n > 1000) n = 1000;
    return Math.floor(n);
  }

  function looksLikeSearchTerm(term) {
    if (!term || term.length > 60) return false;
    // Server rejects terms without [a-z0-9]; skip obvious junk client-side.
    if (!/[a-z0-9]/i.test(term)) return false;
    if (/@/.test(term)) return false;
    if (/https?:\/\//i.test(term)) return false;
    return true;
  }

  function postSearch(term, results) {
    term = normalizeTerm(term);
    if (!looksLikeSearchTerm(term)) return;
    results = clampResults(results);

    var key = term.toLowerCase() + '|' + results;
    var now = Date.now();
    if (recent[key] && now - recent[key] < DEDUPE_MS) return;
    recent[key] = now;

    var body = JSON.stringify({ term: term, results: results });
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        mode: 'cors',
        credentials: 'omit',
        keepalive: true
      }).catch(function () { /* ignore */ });
    } catch (e) {
      /* ignore */
    }
  }

  window.__ghShopSearchCapture = postSearch;

  function bootFromDom() {
    var el = document.getElementById('gh-shop-search-capture');
    if (!el) return;
    var term = el.getAttribute('data-term') || '';
    var results = parseInt(el.getAttribute('data-results') || '0', 10);
    if (term) postSearch(term, results);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFromDom);
  } else {
    bootFromDom();
  }
})();
